// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3Ci5w","colMaxWidth":"Table_colMaxWidth__3eabh"};